import React, { useState, useEffect } from 'react';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress, Dialog } from '@mui/material';
import { FetchEntities } from '../../../../services/api';
import CreateEntityForm from './CreateEntityForm';

import usePermission from '../../../../hooks/usePermission';

const EntitiesList = () => {
    const [entities, setEntities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openCreate, setOpenCreate] = useState(false);
    const token = localStorage.getItem('accessToken');
    const { can } = usePermission();

    useEffect(() => {
        loadEntities();
    }, []);

    const loadEntities = async () => {
        setLoading(true);
        const response = await FetchEntities(token);
        if (response?.data?.entities) {
            setEntities(response.data.entities);
        } else if (response?.data?.data) {
             setEntities(response.data.data);
        }
        setLoading(false);
    };

    if (loading) return <CircularProgress />;

    return (
        <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">Entities</Typography>
                {can('settings.entities.create') && (
                    <Button variant="contained" color="primary" onClick={() => setOpenCreate(true)}>Create Entity</Button>
                )}
            </Box>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Code</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {entities.map((entity) => (
                            <TableRow key={entity.id}>
                                <TableCell>{entity.entityName}</TableCell>
                                <TableCell>{entity.entityCode}</TableCell>
                                <TableCell>{entity.isActive ? 'Active' : 'Inactive'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={openCreate} onClose={() => setOpenCreate(false)} maxWidth="md" fullWidth>
                <CreateEntityForm onClose={() => setOpenCreate(false)} onSuccess={loadEntities} />
            </Dialog>
        </Box>
    );
};

export default EntitiesList;
